// src/pages/WorkerProfile.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_WRK = process.env.REACT_APP_API_WRK;

const WorkerProfile = () => {
  const navigate = useNavigate();
  const workerId = localStorage.getItem("workerId");

  const [workerData, setWorkerData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    profilePhotoUrl: null,
    tier: "silver",
    status: "pending",
  });

  useEffect(() => {
    if (!workerId) {
      navigate("/worker-login");
      return;
    }

    axios
      .get(`${API_WRK}/profile/${workerId}`)
      .then((res) => setWorkerData(res.data))
      .catch((err) => console.error("❌ Failed to load worker:", err));
  }, [workerId, navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/worker-login");
  };

  const verified = workerData.status === "approved";

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans pb-20">
      {/* PAGE HEADER ONLY */}
      <h1 className="text-lg font-semibold border-b w-full text-center py-4">
        Worker Profile
      </h1>

      {/* Profile Photo */}
      <div className="flex flex-col items-center mt-6 mb-2">
        <div className="w-24 h-24 rounded-full overflow-hidden border border-gray-300 bg-gray-100">
          {workerData.profilePhotoUrl ? (
            <img
              src={`${API_WRK.replace("/api/worker", "")}${workerData.profilePhotoUrl}`}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex items-center justify-center h-full text-3xl font-bold text-gray-400">
              {workerData.name?.[0] || "W"}
            </div>
          )}
        </div>

        {/* Verification */}
        <p className="text-xs text-gray-500 mt-1">
          {verified ? "Verified Identity ✔" : "Not Verified Yet"}
        </p>

        <h2 className="mt-3 text-[17px] font-semibold">
          {workerData.name}
        </h2>
      </div>

      {/* INFO SECTION */}
      <div className="w-full max-w-md mx-auto mt-4 border-t border-gray-200">

        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-100">
          <span className="font-medium">Tier</span>
          <span className="text-blue-600 font-semibold uppercase">{workerData.tier}</span>
        </div>

        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-100">
          <span className="font-medium">Profile Status</span>
          <span className="text-gray-500 capitalize">{workerData.status}</span>
        </div>

        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-100">
          <span className="font-medium">Email</span>
          <span className="text-gray-500 truncate">{workerData.email}</span>
        </div>

        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-100">
          <span className="font-medium">Phone</span>
          <span className="text-gray-500">{workerData.phone}</span>
        </div>

        <div className="px-6 py-3 border-b border-gray-100">
          <span className="font-medium block mb-1">Full Address</span>
          <span className="text-gray-600 text-sm">
            {workerData.address} <br />
            {workerData.city}, {workerData.province} {workerData.postalCode}
          </span>
        </div>

        <div
          onClick={() => navigate("/help")}
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">Support</span>
          <span className="text-gray-400">›</span>
        </div>

        <div
          onClick={() => navigate("/documents")}
          className="flex justify-between items-center px-6 py-3 border-b border-gray-100 cursor-pointer hover:bg-gray-50"
        >
          <span className="font-medium">Request Profile Changes</span>
          <span className="text-gray-400">›</span>
        </div>

        <div
          onClick={handleLogout}
          className="text-center text-red-600 font-semibold py-4 cursor-pointer hover:bg-gray-100"
        >
          Log Out
        </div>
      </div>
    </div>
  );
};

export default WorkerProfile;
